import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const formatClassOrSeminar = ({
	cs_desc: desc,
	cs_sponsor: sponsor,
	cs_time: time,
}) => {
	let classOrSeminar = desc;

	if (sponsor) {
		classOrSeminar += `, ${sponsor}`;
	}
	if (time) {
		classOrSeminar += `, ${time}`;
	}

	return classOrSeminar;
};

const ClassesSeminars = (props) => {
	const classesSeminars = props.data.classes_seminars;

	if (!_.isArray(classesSeminars) || _.isEmpty(classesSeminars)) {
		return null;
	}

	return (
		<ul className="bio-list">
			{_.map(classesSeminars, classOrSeminar => (
				<li className="bio-list__item" key={_.uniqueId('list-item-')}>
					{formatClassOrSeminar(classOrSeminar)}
				</li>
			))}
		</ul>
	);
};

ClassesSeminars.propTypes = {
	data: PropTypes.object.isRequired,
};

export default ClassesSeminars;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/classes-seminars.js